export default __webpack_public_path__ + "static/media/doctor_4.ab243959.png";